import { render, staticRenderFns } from "./prePayOrdersDY.vue?vue&type=template&id=406d67aa&scoped=true"
import script from "./prePayOrdersDY.vue?vue&type=script&lang=js"
export * from "./prePayOrdersDY.vue?vue&type=script&lang=js"
import style0 from "./prePayOrdersDY.vue?vue&type=style&index=0&id=406d67aa&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "406d67aa",
  null
  
)

export default component.exports